import "./publishingDisclaimer.scss";

export default function PublishingDisclaimer({ disclaimer }) {
  return (
    <div className="publishingDisclaimer">
      <p>{disclaimer}</p>
    </div>
  );
}
